import { watchAddToCartSaga } from './AddToCart.saga';
import { rootAddToCartRecommendationsSaga } from './Recommendations.saga';

export const SAGAS = [watchAddToCartSaga, rootAddToCartRecommendationsSaga];
